{
  "actions": "Ações"
}
